import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiX } from 'react-icons/fi';

// Modal reutilizable.
export default function Modal({ abierto, onCerrar, titulo, children, ancho = 520, zIndex }) {
  return (
    <AnimatePresence>
      {abierto && (
        <motion.div
          className="modal-overlay"
          style={zIndex ? { zIndex } : undefined}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onCerrar}
        >
          <motion.div
            className="modal"
            style={{ maxWidth: ancho }}
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-title"
            initial={{ opacity: 0, y: 24, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 24, scale: 0.98 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header">
              <h3 id="modal-title">{titulo}</h3>
              <button className="modal-close" onClick={onCerrar} aria-label="Cerrar"><FiX /></button>
            </div>
            <div className="modal-body">{children}</div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
